import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface DetailActionsProps {
  videoId: string;
  title: string;
}

export default function DetailActions({ videoId, title }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [toast, setToast] = useState("");
  const favorited = isFavorite(videoId);

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2000);
  };

  const onFavorite = () => {
    const now = toggleFavorite(videoId);
    showToast(now ? "已加入收藏" : "已取消收藏");
  };

  const onShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <button
        type="button"
        onClick={onFavorite}
        className={`px-6 py-3 rounded-md text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 ${
          favorited
            ? "bg-accent-500 text-primary-950 hover:bg-accent-400"
            : "bg-background-50/10 border border-background-100/40 text-background-50 hover:bg-background-50/20"
        }`}
        aria-pressed={favorited}
      >
        <i className={favorited ? "ri-heart-fill" : "ri-heart-line"} aria-hidden="true"></i>
        {favorited ? "已收藏" : "收藏"}
      </button>
      <button
        type="button"
        onClick={onShare}
        className="px-6 py-3 rounded-md bg-background-50/10 border border-background-100/40 text-background-50 text-sm font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
      >
        <i className="ri-share-forward-line" aria-hidden="true"></i>
        分享
      </button>

      {toast && (
        <span className="px-4 py-2 rounded-md bg-primary-950/90 text-background-50 text-sm animate-fade-up" role="status">
          {toast}
        </span>
      )}
      <span className="sr-only">{title}</span>
    </div>
  );
}